import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { registerComponents } from "@/components";
// import vuetify from "./plugins/vuetify";

// import { instance, axios } from "./services/axios";
// import { setupConfig } from "./services/config";
import "./plugins/fontawesome";
import mitt from "mitt";
import vueDebounce from "vue-debounce";
import VueNumerals from "vue-numerals";
import numeral from "numeral";
import VueCookies from "vue-cookies";
import liff from "@line/liff";
import swal from "sweetalert";
import DatetimePicker from "vuetify-datetime-picker";
import moment from "moment";
import VueClipboard from "vue-clipboard2";
import QrcodeVue from "qrcode.vue";
import dictionary from "./lang";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import { appConfig } from "./aLwAJXh7rUuwykLl";
import {
  genarateFont,
  setupConfig,
  instance,
  axios,
  logger,
  loadVuetifyTheme
} from "./services";
import "vuetify/styles";
import "./style.css";
import "@mdi/font/css/materialdesignicons.css";

const emitter = mitt();
var liffMock = null;
const app = createApp({
  extends: App
});
app.config.globalProperties.$appConfig = appConfig;
app.component("VueDatePicker", VueDatePicker);
app.component("QrcodeVue", QrcodeVue);
app

  .use(VueClipboard)
  .use(vueDebounce)
  .use({
    install(Vue) {
      app.config.globalProperties.$swal = swal;
    }
  })
  .use(VueCookies)
  .use(DatetimePicker)
  .use(VueNumerals);

VueClipboard.config.autoSetContainer = true; // add this line
app.config.globalProperties.$apiKey = "ChAtA7Ds40p";
app.config.globalProperties.$formatDate = "DD MMM YYYY";
app.config.globalProperties.$formatDateTime = "DD MMM YYYY HH:mm";
app.config.globalProperties.$logger = ({ response, action }) =>
  logger({ response, action });
if (window.Cypress) {
  app.config.globalProperties.$liff = window.Cypress.liffMock;
} else {
  app.config.globalProperties.$liff = liff;
}

app.config.globalProperties.handleImageSrc = require("@/assets/images/default-image.png");
app.config.globalProperties.$Endpoint = window.location.origin;
app.config.globalProperties.$nissinTransaction =
  appConfig.VUE_APP_TRANSACTION_API ||
  "https://api-middleware-nissin.d-dots.com/api/transactioncode/redeem";
app.config.globalProperties.$store = store;
app.config.globalProperties.$router = router;
app.config.globalProperties.$axios = instance;
app.config.globalProperties.axios = axios;
app.config.globalProperties.emitter = emitter;

app.config.globalProperties.moment = date => moment(date);

app.config.globalProperties.convertTelePhone = val => {
  if (!val) return null;

  if (val.includes("-")) {
    let value = val.split("-");
    return ` ${value[0]} - ${value[1]}`;
  }
  return ` ${val}`;
};
app.config.globalProperties.displayAddress = val => {
  if (!val) return "";

  const {
    address,
    home_address,
    building_name,
    alley,
    road,
    sub_district,
    subdistrict,
    district,
    province,
    zip_code,
    country
  } = val;

  const isBkk = province?.includes("กรุงเทพ") || false;
  const isTH = country ? country === "ประเทศไทย" : true;

  const parts = [];

  if (address || home_address) parts.push(address || home_address);
  if (building_name) parts.push(building_name);
  if (alley) parts.push(alley);
  if (road) parts.push(`${isTH ? "ถนน" : ""}${road}`);
  if (sub_district || subdistrict)
    parts.push(
      `${isTH ? (isBkk ? "แขวง" : "ตำบล") : ""}${sub_district || subdistrict}`
    );
  if (district)
    parts.push(`${isTH ? (isBkk ? "เขต" : "อำเภอ") : ""}${district}`);
  if (province) parts.push(`${isTH && !isBkk ? "จังหวัด" : ""}${province}`);
  if (zip_code) parts.push(zip_code);
  if (country) parts.push(country);

  return parts.join("&nbsp;");
};
const originalFetch = window.fetch;
function customFetch(url, options) {
  if (
    url.toString().startsWith("https://liffsdk.line-scdn.net/xlt/") &&
    url.toString().endsWith(".json")
  ) {
    url = url + "?ts=" + Math.random();
  }
  return originalFetch(url, options);
}
window.fetch = customFetch;

const getLiffIdFromUrl = rawUrl => {
  if (!rawUrl) return "";

  try {
    const url = new URL(rawUrl);
    return url.pathname.split("/").filter(Boolean)[0] || "";
  } catch {
    return String(rawUrl).split(/[?#]/)[0].split("/").filter(Boolean).pop() || "";
  }
};

async function initializeApp() {
  const config = await setupConfig();
  if (!config) return config;

  // Extract brand from hostname
  const hostname = window.location.hostname;
  const brand = hostname.split("-")[0];
  console.log("Brand:", brand);
  // Setup LIFF ID
  let liffId = "";
  liffMock = liff;
  if (brand === "1sgd2ss3") {
    liffId = "1656234832-gyrQbQVW";
  } else if (brand === "5w48tpk6") {
    liffId = "1656234832-M6VoLoxG";
  } else if (brand === "j7gz8s68") {
    liffId = "1656234832-M6VoLoxG"
    // liffId = "2010446657-V8tMnyPF";
  } else {
    liffId = getLiffIdFromUrl(config.memberLiffUrl);
  }

  // If testing with Cypress
  if (window.Cypress) {
    liffId = window.Cypress.liffMock.liffId;
    liffMock = window.Cypress.liffMock;
    app.config.globalProperties.$liffId = liffId;
  } else {
    app.config.globalProperties.$liffId = liffId;
  }

  // Load theme settings
  const data = await instance(`/api/v1/Setting/theme`);

  if (config.member_url) {
    config.isLoginLine = !config.member_url.includes(window.location.host);
  } else {
    config.isLoginLine = true;
  }
  function getRawParam(key) {
    const match = window.location.search.match(
      new RegExp(`[?&]${key}=([^&]*)`)
    );
    return match ? decodeURIComponent(match[1].replace(/\+/g, "%2B")) : null;
  }

  const member = getRawParam("member");
  const token_bypass = window.sessionStorage.getItem("token_bypass", member);

  if (member || token_bypass) {
    VueCookies.remove("token");
    VueCookies.remove("user_profile_token");
    config.socialProvider = "memberlink";
    config.socialID = member || token_bypass;
    window.localStorage.setItem("from_bypass", 1);
    if (!token_bypass) window.sessionStorage.setItem("token_bypass", member);
  } else if (config.isLoginLine) {
    config.socialProvider = "line";
    config.socialID = VueCookies.isKey("user_profile_token")
      ? VueCookies.get("user_profile_token").userId
      : null;
  } else {
    VueCookies.remove("user_profile_token");
    config.socialProvider = "telephone";
    config.socialID = VueCookies.get("telephone_login");
  }
  // data.result.line_layout = "Minimal - Profile Banner";
  setProperty({ data, config });

  if (data.result.line_layout == "Minimal UI - Profile Banner") {
    app.config.globalProperties.numeralFormat = (value, format = "0,0") =>
      numeral(value).format(format).replace(/,/g, ".");
  }

  await getLanguage(data);
  app.config.globalProperties.$getLang = () => getLanguage(data);

  registerComponents(app, data.result.line_layout);

  // Choose Vuetify theme based on layout
  let vuetify;
  const layout = data.result.line_layout;
  // config.isMinimalCompact = false;
  config.isMinimalSharp = false;
  if (layout.includes("Minimal")) {
    if (layout.includes("Compact")) {
      // config.isMinimalCompact = true;
      vuetify = loadVuetifyTheme("Compact");
    } else if (layout.includes("Sharp")) {
      config.isMinimalSharp = true;
      vuetify = loadVuetifyTheme("Sharp");
    } else if (layout.includes("Minibar")) {
      vuetify = loadVuetifyTheme("Minibar");
    } else if (
      layout.includes("- Profile") &&
      layout != "Minimal UI - Profile Banner"
    ) {
      vuetify = loadVuetifyTheme("MinimalProfile");
    } else if (layout.includes("Clean")) {
      vuetify = loadVuetifyTheme("Clean");
    } else if (layout.includes("Banner")) {
      vuetify = loadVuetifyTheme("Banner");
    } else {
      vuetify = loadVuetifyTheme("Minimal");
    }
  } else {
    vuetify = loadVuetifyTheme("Default");
  }

  if (liff && liffId) await liffMock.init({ liffId });

  app.use(router).use(store).use(vuetify).mount("#app");

  return config;
}

function setProperty({ data, config }) {
  store.commit("setTheme", data);
  if (config.custom_js) convertCustomJs(config.custom_js);
  genarateFont(config);

  app.config.globalProperties.$config = config;

  let brand = window.location.hostname.split("-")[0];
  app.config.globalProperties.$BRAND = config.brand_name;
  app.config.globalProperties.displayUpcomming =
    config.display_upcomming_redeem == 1 ? true : false;
  app.config.globalProperties.displayMission =
    config.line_display_mission == 1 ? true : false;
  app.config.globalProperties.rewardProgress =
    config.display_reward_progress == 1 ? true : false;
  app.config.globalProperties.yearFormat = data.result.year_format;
  app.config.globalProperties.$isStandardV2 =
    data.result.line_layout == "standard-v2";
  if (data.result.line_layout.includes("Minimal")) {
    app.config.globalProperties.$isShowTab =
      data.result.line_layout == "Minimal UI - Tab bar";
    app.config.globalProperties.$isCleanLayout =
      data.result.line_layout == "Minimal UI - Clean";
    app.config.globalProperties.$isMinimalProfile =
      data.result.line_layout == "Minimal UI - Profile";
    app.config.globalProperties.$isMinimalMinibar =
      data.result.line_layout == "Minimal UI - Minibar";
    app.config.globalProperties.$isMinimalCompact =
      data.result.line_layout == "Minimal UI - Compact" ||
      data.result.line_layout == "Minimal UI – Sharp";
    app.config.globalProperties.$isMinimalProfileBanner =
      data.result.line_layout == "Minimal UI - Profile Banner";
    if (data.result.line_layout == "Minimal UI - Clean")
      app.config.globalProperties.lineLayout = data.result.line_layout;
    else if (data.result.line_layout == "Minimal UI - Profile")
      app.config.globalProperties.lineLayout = data.result.line_layout;
    else app.config.globalProperties.lineLayout = "Minimal";
  } else {
    app.config.globalProperties.lineLayout = data.result.line_layout;
    app.config.globalProperties.isTierFullDisplay =
      data.result.line_layout == "Tier (Full Display)";
    app.config.globalProperties.isTierUpgradeTier =
      data.result.line_layout == "Tier (Upgrade Tier)";
  }
}
function convertCustomJs(a) {
  try {
    if (a)
      for (var element of a.split("</script>")) {
        if (element) {
          if (!element.includes("<script")) {
            element = `<script>${element}</script>`;
          }
          const fragment = document
            .createRange()
            .createContextualFragment(element);
          document.body.appendChild(fragment);
        }
      }
  } catch (err) {}
}
async function getLanguage(data, lang_id = 1) {
  const res = await store.dispatch("getLanguage");
  function getRawParam(key) {
    const match = window.location.search.match(
      new RegExp(`[?&]${key}=([^&]*)`)
    );
    return match ? decodeURIComponent(match[1].replace(/\+/g, "%2B")) : null;
  }

  const setLangCookie = (id, name, flag) => {
    VueCookies.set(
      "lang",
      JSON.stringify({ lang: id, name: name || "th", flag: flag || "🇹🇭" })
    );
  };

  const $lang = getRawParam("lang_id");
  const _lang = $lang ? res.find(el => el.id == $lang) : null;

  if (!VueCookies.isKey("lang")) {
    if (_lang) {
      setLangCookie(_lang.id, _lang.name, _lang.image_url);
      lang_id = _lang.id;
    } else {
      setLangCookie(res[0]?.id, res[0]?.name, res[0]?.image_url);

      lang_id = res[0]?.id || 1;
    }
  } else {
    if (_lang) {
      setLangCookie(_lang.id, _lang.name, _lang.image_url);
      lang_id = _lang.id;
    } else {
      const cookieLang = VueCookies.get("lang");
      const foundLang = res.find(el => el.id == cookieLang?.lang);
      if (foundLang) {
        lang_id = cookieLang.lang;
      } else {
        setLangCookie(res[0]?.id, res[0]?.name, res[0]?.image_url);
        lang_id = res[0]?.id || 1;
      }
    }
  }

  const result = await instance(
    `/api/v1/setting/display_language/label/${lang_id}`
  );
  const cookieLang = VueCookies.get("lang");
  const lang = cookieLang?.name || "th";

  const momentLang =
    data.result.line_layout == "Minimal UI - Profile"
      ? "en"
      : lang === "zh"
      ? "zh-cn"
      : lang;
  app.config.globalProperties.$moment = date => {
    const m = moment(date).locale(momentLang);
    return data.result.year_format == 1 ? m.add(543, "year") : m;
  };
  let obj = {};
  const labelData = result?.detail?.label || result.detail;
  for (const el of labelData) {
    if (result.detail.default_label) {
      let defaultValue = result.detail.default_label.find(
        a => a.label_id == el.label_id
      )?.name;
      obj[el.label_name] = el?.name || defaultValue || "";
    } else {
      obj[el.label_name] = el.name;
    }
  }
  app.config.globalProperties.$t = val => dictionary(obj, val);

  return obj;
}

async function init() {
  try {
    return await initializeApp();
  } catch (error) {
    console.log(error);
  }
}

const config = await init();
export { liff, config, liffMock };
